import axios from 'axios';

const API_URL = 'https://qwikbistro.shop';
// const TOKEN = "ad269451f183b23a15385b4c00469e6e62daef98";
const TOKEN = process.env.REACT_APP_QWIK_BISTRO_API_TOKEN;


const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Authorization': `Bearer ${TOKEN}`,
    'Content-Type': 'application/json',
  },
});

export const customerApiService = {
  // Get all customers
  getAllCustomers: async () => {
    try {
      const response = await axiosInstance.get('/userProfile/');
      return response.data.sort((a, b) => b.id - a.id); // Latest first
    } catch (error) {
      console.error('Error fetching customers:', error);
      throw error;
    }
  },

  // Get single customer
  getCustomer: async (id) => {
    try {
      const response = await axiosInstance.get(`/userProfile/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching customer:', error);
      throw error;
    }
  },

  // Update customer
  updateCustomer: async (id, customerData) => {
    try {
      const response = await axiosInstance.patch(`/userProfile/${id}`, customerData);
      return response.data;
    } catch (error) {
      console.error('Error updating customer:', error);
      throw error;
    }
  },

  // Delete customer
  deleteCustomer: async (id) => {
    try {
      await axiosInstance.delete(`/userProfile/${id}`);
      return true;
    } catch (error) {
      console.error('Error deleting customer:', error);
      throw error;
    }
  },

  // Create new customer
  createCustomer: async (customerData) => {
    try {
      const response = await axiosInstance.post('/userProfile', customerData);
      return response.data;
    } catch (error) {
      console.error('Error creating customer:', error);
      throw error;
    }
  },
};